function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 30
// module chunks = 104158497352714 128747004913641